import axios from 'axios';

const NTS_CADASTRAL_NUMBERS_URL = '/reports/nts/cadastral-numbers/';

export const getNTSById = async (id, signal) => {
  const url = `/reports/nts/${id}/?utm_coords=true`;
  const response = await axios.get(url, { signal });
  return response;
};

export const getNtsCadastralNumbers = async ({ localCommunity, search, signal } = {}) => {
  const params = {
    lc: localCommunity || undefined,
    search: search || undefined,
  };

  return axios.get(NTS_CADASTRAL_NUMBERS_URL, {
    params,
    signal,
  });
};

export const rejectNtsReport = async (id, body) => {
  const url = `/validations/nts/${id}/imsma-reject/`;
  const response = await axios.patch(url, body);
  return response;
};

export const localRejectNtsReport = async (id, body) => {
  const url = `/validations/nts/${id}/local-reject/`;
  const response = await axios.patch(url, body);
  return response;
};
